import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import BColor from '../BColor'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        marginLeft: 5,
        marginRight: 5,
        paddingLeft: 5,
        paddingRight: 5
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.background.default,
        // },
    },
}))(TableRow);

function createData(ymd, pl, y1, y2, q1, q2, nopil, y3, y4, q3, q4, iteco, y5, y6, q5, q6) {
    return {ymd, pl, y1, y2, q1, q2, nopil, y3, y4, q3, q4, iteco, y5, y6, q5, q6};
}


const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 250,
      backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
    },
    button1: {
      minWidth: 110,
    }
  }));

export default function FinRateList(props) {
    const classes = useStyles();
    const [buyselldata, setBuyselldata] = React.useState([]);
    // const items = [{
    //     id: "1", text:"test1"
    // },
    // {
    //     id: "2", text:"test2"
    // },{
    //     id: "3", text:"test3"
    // }];

    // const items1 = ["test1", "test2", "test3"];

    useEffect(() => {
        if(props.open) fectchStockData(props.stockId)
    }, [props.stockId]);


    function fectchStockData(stockId) {
        if(stockId != null) {
            let a = {
                sid: stockId,
                inp: {}
            };

            fetch("/jstock/v1/stock/pllist", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        if(result.l != undefined) {
                            let dd = result.l.map(row =>
                                createData(row.ymd, 
                                row.pl, row.y1, row.y2, row.q1, row.q2, 
                                row.nopil, row.y3, row.y4, row.q3, row.q4,
                                row.iteco, row.y5, row.y6, row.q5, row.q6
                                )
                            )
                            setBuyselldata(dd)
                        }
                    },
                    error => {
                    }
                );
        }
    }


    function renderValue3(value) {
        let colorx = BColor.faircolor
        let word = value
        
        if(value < 0 && value != -99999)
        colorx="#87c988"

        if(value === -99999) word = "-"

        return <Button size="small" variant="outlined" style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}%</Button>
    }

    function renderValue1(value, value1, unit) {
        let colorx = BColor.faircolor
        let word = ''

        if (value === 0) {
            colorx = BColor.downcolorbox
            word = '虧轉虧' 
        } else if (value === 1) {
            colorx = BColor.upcolorbox
            word = '虧轉盈' 
        } else if (value === 2) {
            colorx = BColor.downcolorbox
            word = '盈轉虧' 
        }  else if (value === 3) {
            if(value1 > 0) {
                colorx = BColor.upcolorbox    
            } else if(value1 < 0) {
                colorx = BColor.downcolorbox
            } else {
                colorx = BColor.faircolor
            }
            word = value1 + unit 
        } else if (value === -1) {
            colorx = BColor.faircolor
            word = '-'            
        }
        // {unit}
        return <Button size="small" variant="outlined" style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}</Button>
    }


    return (
        <Dialog 
        // fullWidth={true}
        maxWidth={'lg'}
         open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{props.stockName}({props.stockId})三率表</DialogTitle>

            <DialogContent>
                {/* <ReorderList items={items}></ReorderList> */}

                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>日期</StyledTableCell>
                                <StyledTableCell align="center">毛利率</StyledTableCell>
                                <StyledTableCell align="center">毛利QoQ</StyledTableCell>
                                <StyledTableCell align="center">毛利YoY</StyledTableCell>
                                <StyledTableCell align="center">營益率</StyledTableCell>
                                <StyledTableCell align="center">營益QoQ</StyledTableCell>
                                <StyledTableCell align="center">營益YoY</StyledTableCell>
                                <StyledTableCell align="center">淨利率</StyledTableCell>
                                <StyledTableCell align="center">淨利QoQ</StyledTableCell>
                                <StyledTableCell align="center">淨利YoY</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd}>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap', marginRight: 5, marginLeft: 5}} align="left">
                                        {row.ymd}
                                    </StyledTableCell>

                                    <StyledTableCell style={{ whiteSpace: 'nowrap', marginRight: 5, marginLeft: 5}} align="center">
                                        {renderValue3(row.pl)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap', marginRight: 5, marginLeft: 5}} align="center">
                                        {renderValue1(row.q1, row.q2, '%')}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue1(row.y1, row.y2, '%')}
                                    </StyledTableCell>


                                    <StyledTableCell style={{ whiteSpace: 'nowrap', marginRight: 5, marginLeft: 5}} align="center">
                                        {renderValue3(row.nopil)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue1(row.q3, row.q4, '%')}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue1(row.y3, row.y4, '%')}
                                    </StyledTableCell>



                                    <StyledTableCell style={{ whiteSpace: 'nowrap', marginRight: 5, marginLeft: 5}} align="center">
                                        {renderValue3(row.iteco)}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue1(row.q5, row.q6, '%')}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue1(row.y5, row.y6, '%')}
                                    </StyledTableCell>

                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}
